// The venue and organisation console (`https://app.{domain}`, spec/13): what `vite build` makes.

import { consoleResources } from '@clavian/i18n/console';

import type { ConsoleSurface } from '../surface';
import { createOrgRouteTree } from './routes';

export const surface: ConsoleSurface = {
  id: 'org',
  name: 'clavian-console',
  createRouteTree: createOrgRouteTree,
  resources: consoleResources,
};
